"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypographyWithMatch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Link_1 = require("../../atoms/Link/Link");
var Typography_1 = require("../../atoms/Typography/Typography");
var TypographyWithMatch_logic_1 = require("./TypographyWithMatch.logic");
/**
 * TypographyWithMatch molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-typographywithmatch--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/TypographyWithMatch Source}
 */
var TypographyWithMatch = function (_a) {
    var className = _a.className, variant = _a.variant, children = _a.children, match = _a.match, rest = __rest(_a, ["className", "variant", "children", "match"]);
    var _b = (0, TypographyWithMatch_logic_1.useTypographyWithMatch)({
        substring: match.placeholder || '%LINK%',
        text: children,
    }), startSlice = _b.startSlice, endSlice = _b.endSlice, hasMatch = _b.hasMatch;
    return ((0, jsx_runtime_1.jsxs)(Typography_1.Typography, __assign({ className: className, variant: variant }, rest, { children: [!!startSlice && startSlice, hasMatch && ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ className: match.className, variant: match.variant || variant, component: 'span', onClick: match.onClick, bold: match.bold, underline: match.underline, color: match.color }, { children: match.url !== undefined ? (0, jsx_runtime_1.jsx)(Link_1.Link, __assign({ url: match.url }, { children: match.text })) : match.text }))), !!endSlice && endSlice] })));
};
exports.TypographyWithMatch = TypographyWithMatch;
